<template>
  <b-table responsive :items="items" :fields="fields">
    <template #head(image)="data">
      <span class="" style="width: 40%">{{ data.label }} ({{ items?.length }})</span>
    </template>
    <template #cell(image)="{ item, index }">
      <div class="d-flex gap-10">
        <img
          v-if="item.imageThumbnail && item.imageThumbnail.length > 0"
          class="order-image"
          :src="item.imageThumbnail[0].original_url"
          alt=""
        />
        <img v-else class="order-image" :src="defaultImage()" alt="" />
        <div class="d-flex flex-column gap-10 align-self-center">
          <a :href="item.slug ? `/products/${item.slug}` : ``" target="_blank"
             class="text-primary text-underline">
            {{ item.name }}
          </a>
          <span v-if="item.product_variant_serial_number"
                v-text="'Serial Number: ' + item.product_variant_serial_number">
          </span>
          <span>{{ item.sku }}</span>
        </div>
      </div>
    </template>
    <template #cell(qty)="{ item, index }">
      <div>{{ item.qty }}</div>
    </template>
    <template #cell(price)="{ item, index }">
      <div v-if="item.is_daily_deal">${{ currencyFormat(item.discount_price, 0, 2) }}</div>
      <div v-else>${{ currencyFormat(item.price, 0, 2) }}</div>
    </template>
    <template #cell(total)="{ item, index }">
      <span>${{ currencyFormat(removeCurrencyFormat(item.price) * removeCurrencyFormat(item.qty), 0, 2) }}</span>
    </template>
  </b-table>
</template>

<script>
import { Trash2Icon, XIcon } from "vue-feather-icons"
import { currencyFormat } from "@core/helpers/configHelper"
import { removeCurrencyFormat } from "../../../helpers/configHelper"

export default {
  name: "OrderTable",
  components: {
    Trash2Icon,
    XIcon
  },
  props: ["items"],
  mounted() {
    console.log("order is : ", this.items)
  },
  data() {
    return {
      fields: [
        { key: "image", label: "Item", thStyle: { width: "60%" } },
        { key: "price", label: "Price" },
        { key: "qty", label: "QTY", class: "text-uppercase" },
        { key: "total", label: "Total" }
        // {key: 'actions', label: 'Actions'}
      ]
    }
  },

  methods: {
    removeCurrencyFormat,
    currencyFormat,
    defaultImage() {
      return `modules/product/images/Vector.svg`
    }
  }
}
</script>

<style scoped>
.text-primary {
  color: #DEAA5E !important;

}

.order-image {
  width: 70px;
  height: 80px;
  position: relative;
  display: flex;
  align-items: center;
  /*border: 1px solid #B5B5B5;*/
  justify-content: center;
  object-fit: contain;
  border-radius: 6px;
}

.color-img-sample.placeholder {
  border: 1px solid #d8d6de;
  padding-left: 1rem;
  color: #b9b9c3;
}

.color-img-sample.placeholder.is-invalid {
  border-color: #ea5455;
}

.hidden {
  display: none;
  visibility: hidden;
}

::v-deep .b-table-fixed {
  table-layout: fixed !important;
}

::v-deep th {
  font-size: 14px !important;
}
</style>
